import React, { Component } from 'react';
import Chart from "react-apexcharts";
import axios from 'axios'
import { Circles } from 'react-loader-spinner'
import ExcelExport from '../ExcelExport/ExcelExport';

export class Chart1 extends Component {
    constructor() {
        super()
        this.state = {
            options: {
                chart: {
                    type: "bar",
                    stacked: false
                },
                xaxis: {
                    categories: []
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val, opts) {
                        const seriesIndex = opts.seriesIndex;
                        const dataPointIndex = opts.dataPointIndex;
                        const series = opts.w.config.series;
                        
                        // Calculate total for this category
                        let total = 0;
                        series.forEach(s => {
                            total += s.data[dataPointIndex] || 0;
                        });
                        
                        // Calculate percentage
                        const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                        return `${val}\n${percentage}%`;
                    },
                    style: {
                        fontSize: '10px',
                        colors: ['#fff'],
                        fontWeight: 'bold'
                    },
                    textAnchor: 'middle',
                    distributed: false,
                    offsetX: 0,
                    offsetY: 0
                },
                tooltip: {
                    y: {
                        formatter: function(val, opts) {
                            const seriesIndex = opts.seriesIndex;
                            const dataPointIndex = opts.dataPointIndex;
                            const series = opts.w.config.series;
                            
                            // Calculate total for this category
                            let total = 0;
                            series.forEach(s => {
                                total += s.data[dataPointIndex] || 0;
                            });
                            
                            // Calculate percentage
                            const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                            return `${val} (${percentage}%)`;
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: 'center'
                        }
                    }
                }
            },
            series: [],
            isLoaded: false,
            filterDate: '',
            non_allocated_shipments : [],
            all_shipments : []
        };
        this.componentDidMount = this.componentDidMount.bind(this)
        this.filterChnage = this.filterChnage.bind(this)
        this.updateChart = this.updateChart.bind(this)
    }

    updateState(name, data) {
        const newSeries = {
            name: name,
            data: data
        };

        this.setState((prevState) => ({
            series: [...prevState.series, newSeries]
        }));
    }

    updateLoader(stateValue) {
        if (this.state.isLoaded === true) {
            this.setState({ isLoaded: false })
        } else {
            this.setState({ isLoaded: stateValue })
        }
    }

    updateCategories(newCategories) {
        this.setState((prevState) => ({
            options: {
                ...prevState.options, // Preserve other properties in the options object
                xaxis: {
                    ...prevState.options.xaxis, // Preserve other properties in xaxis
                    categories: newCategories, // Update categories with the new data
                },
            },
        }));
    }

    filterChnage(event) {
        console.log(event.target.value)
        this.setState({ filterDate: event.target.value })
    }

    getData(formData) {
        const API_URL = process.env.REACT_APP_API_URL
        const token = localStorage.getItem("authTokenLoop");
        const dataUrl = API_URL + "/Bi_dashboard_ota"

        const time_slot = [];
        const arranged_count = [];
        const not_arranged_count = [];

        axios({
            method: 'post',
            url: dataUrl,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data', // Set the Content-Type header to multipart/form-data
                'Authorization': 'Bearer ' + token,
            },
        }).then((response) => {
            if (response.data.success) {
                const reportData = response.data.data.report_data;
                reportData.forEach(item => {
                    const timeSlotStart = item.time_slot[0];
                    const timeSlotEnd = item.time_slot[1];
                    const formattedTimeSlot = `${timeSlotStart} - ${timeSlotEnd}`;
                    time_slot.push(formattedTimeSlot);
                    arranged_count.push(item.arranged_count);
                    not_arranged_count.push(item.not_arranged_count);

                });
                const non_allocated_records = response.data.data.non_allocated_shipments;
                const all_shipments = response.data.data.all_shipments;
                this.setState({non_allocated_shipments:non_allocated_records})
                this.setState({all_shipments:all_shipments})
                console.log(non_allocated_records);
                this.setState({ series: [] })
                this.setState({ 
                    options: { 
                        chart: { 
                            type: "bar",
                            stacked: false 
                        }, 
                        xaxis: { 
                            categories: [] 
                        },
                        dataLabels: {
                            enabled: true,
                            formatter: function (val, opts) {
                                const seriesIndex = opts.seriesIndex;
                                const dataPointIndex = opts.dataPointIndex;
                                const series = opts.w.config.series;
                                
                                // Calculate total for this category
                                let total = 0;
                                series.forEach(s => {
                                    total += s.data[dataPointIndex] || 0;
                                });
                                
                                // Calculate percentage
                                const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                                return `${val} | ${percentage}%`;
                            },
                            style: {
                                fontSize: '9px',
                                colors: ['#fff'],
                                fontWeight: 'bold'
                            },
                            background: {
                                enabled: true,
                                foreColor: '#3f3f3fff',
                                borderRadius: 3,
                                padding: 3,
                                opacity: 0.8,
                                borderWidth: 1,
                                borderColor: '#555555',
                                dropShadow: {
                                    enabled: false
                                }
                            },
                            textAnchor: 'middle',
                            distributed: false,
                            offsetX: 0,
                            offsetY: -5
                        },
                        tooltip: {
                            y: {
                                formatter: function(val, opts) {
                                    const seriesIndex = opts.seriesIndex;
                                    const dataPointIndex = opts.dataPointIndex;
                                    const series = opts.w.config.series;
                                    
                                    // Calculate total for this category
                                    let total = 0;
                                    series.forEach(s => {
                                        total += s.data[dataPointIndex] || 0;
                                    });
                                    
                                    // Calculate percentage
                                    const percentage = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                                    return `${val} (${percentage}%)`;
                                }
                            }
                        },
                        plotOptions: {
                            bar: {
                                dataLabels: {
                                    position: 'center'
                                }
                            }
                        }
                    } 
                })

                this.updateCategories(time_slot)
                this.updateState("Arranged", arranged_count)
                this.updateState("Not arranged", not_arranged_count)
                this.updateLoader(true)
            } else {
                console.log("No data returned from API")
                this.updateLoader(true)
            }
        }).catch(function (error) {
            console.log(error);
        });
    }

    updateChart() {
        const newDate = this.state.filterDate;
        const formData = new FormData();
        formData.append('filter_date', newDate);
        this.setState({ isLoaded: false })
        this.getData(formData);
    }

    componentDidMount() {
        const formData = new FormData();
        var currentDate = new Date();
        var currentDate = new Date(currentDate.getTime() - 86400000);
        var formattedDate = currentDate.toISOString().split('T')[0];
        formData.append('filter_date', formattedDate);
        this.setState({ filterDate: formattedDate })
        this.getData(formData);
    }

    render() {
        return (
            <div className={`card col-12 m-4`} style={{ height: '70vh' }}>
                <div className='card-header border-0 pt-5'>
                    <div className='row'>
                        <div className='col-7'>
                            <p className='card-title align-items-start flex-column'>
                                <span className='card-label fw-bold mb-1'>On Time Arrangement  <br /> <span style={{ color: '#A3A5A6' }}>{this.state.filterDate}</span> </span>
                            </p>
                        </div>
                        <div className='col-2 d-flex justify-content-center'>
                            <button
                                type='button'
                                className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                                data-kt-menu-trigger='click'
                                data-kt-menu-placement='bottom-end'
                                data-kt-menu-flip='top-end'
                                style={{ width: 'auto', minWidth: '80px' }}>
                                <i className='fas fa-filter mx-1'></i> Filter
                            </button>

                            <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
                                <div className='px-7 py-5'>
                                    <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
                                </div>

                                <div className='separator border-gray-200'></div>

                                <div className='px-7 py-5'>
                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDate} className='form-control' onChange={this.filterChnage} />
                                        </div>
                                    </div>

                                    <div className='d-flex justify-content-end'>
                                        <button
                                            type='reset'
                                            className='btn btn-sm btn-white btn-active-light-primary me-2'
                                            data-kt-menu-dismiss='true'>
                                            Reset
                                        </button>

                                        <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true' onClick={this.updateChart}>
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='col-3 d-flex justify-content-end align-items-center' style={{ height: 'fit-content' }}>
                            <ExcelExport data={this.state.all_shipments} fileName="On Time Arrangement Export" />
                        </div>
                    </div>

                </div>

                <div className='card-body'>
                    <div className='row'>
                        <div className='col-6'>
                            <div id='loader' className={this.state.isLoaded == true && 'd-none'} style={{ height: "100%", width: "150%" }}>
                                <Circles
                                    height="100%"
                                    width="40%"
                                    color="#FF870D"
                                    ariaLabel="circles-loading"
                                    wrapperStyle={{ padding: "15% 0", marginLeft: "16%" }}
                                    wrapperClass=""
                                    visible={true}
                                />
                            </div>

                            <div id='loader' className={!this.state.isLoaded == true && 'd-none'} style={{ height: "500px" }}>
                                <Chart
                                    options={this.state.options}
                                    series={this.state.series}
                                    type="bar"
                                    width="100%"
                                    height="100%"
                                />
                            </div>
                        </div>
                        <div className='col-6' style={{height: "200px", overflow: "auto" }}>
                            <table className='table table-bordered' style={{ border: '1px solid black'}}>
                                <thead>
                                    <tr style={{ backgroundColor: '#DBDEE0' }}>
                                        <th style={{ border: '1px solid black', padding: '1%' }}>Date</th>
                                        <th style={{ border: '1px solid black', padding: '1%' }}>Time Interval</th>
                                        <th style={{ border: '1px solid black', padding: '1%' }}>Shipment #</th>
                                        <th style={{ border: '1px solid black', padding: '1%' }}>Gate Pass Print Time</th>
                                        <th style={{ border: '1px solid black', padding: '1%' }}>Vehicle #</th>
                                        <th style={{ border: '1px solid black', padding: '1%' }}>OTA / Non OTA</th>
                                        <th style={{ border: '1px solid black', padding: '1%' }}>Trip Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.all_shipments.map((record,index) => (
                                    <tr key={index}>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{record.shipment_date}</td>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{record.time_interval_id}</td>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{record.shipment_number}</td>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{record.gate_pass_last_print_time}</td>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{(()=>{
                                            if(record.vehicle_number==null){
                                                return "N/A";
                                            }
                                            else{
                                                return record.vehicle_number;
                                            }
                                        })()}</td>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{record.status}</td>
                                        <td style={{ border: '1px solid black', padding: '1%' }}>{record.tms_shp_trip_mode}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}